import qs from 'qs';
/**
 * Получить функцию-сериалайзер
 *
 * @param indices параметр, указывающий на метод сериализации списков в виде item[0]=value&item[1]=value...
 */
export function getParamSerializer(indices: boolean = false) {
    return (params: any[]) => {
        return qs.stringify(params, {
            skipNulls: true,
            allowDots: true,
            arrayFormat: indices ? 'indices' : 'repeat',
        });
    };
}
